import PropTypes from 'prop-types';
import { BsInfoCircle, BsChevronUp, BsChevronDown } from 'react-icons/bs';

export const TypeBadge = ({ type }) => (
	<span
		className={`text-[10px] font-semibold px-1.5 py-0.5 rounded whitespace-nowrap ${type === 'hr' ? 'bg-primary-100 text-primary-700' : 'bg-green-50 text-success-700'}`}
	>
		{type === 'hr' ? 'Handelsregister' : 'Karten-Suche'}
	</span>
);

TypeBadge.propTypes = { type: PropTypes.oneOf(['maps', 'hr']).isRequired };

/**
 * Collapsible filter card of the search criteria grid; shows a one-line summary while collapsed.
 */
export const CollapseCard = ({
	icon: Icon,
	title,
	type,
	summary,
	open,
	onToggle,
	disabled,
	reason,
	span2,
	children,
}) => (
	<div
		className={`${span2 ? 'col-span-2' : ''} bg-white rounded-xl border border-gray-200 shadow-sm ${disabled ? 'bg-gray-50/40' : ''}`}
	>
		<button
			type="button"
			onClick={disabled ? undefined : onToggle}
			disabled={disabled}
			className={`w-full flex items-center gap-2 px-4 py-3 text-left rounded-t-xl transition-colors ${disabled ? 'cursor-default' : 'hover:bg-gray-50/60'} ${open ? '' : 'rounded-b-xl'}`}
		>
			<Icon className={`w-4 h-4 flex-shrink-0 ${disabled ? 'text-bgBase-800' : 'text-primary-600'}`} />
			<span className={`text-sm font-semibold flex-shrink-0 ${disabled ? 'text-bgBase-800' : 'text-text'}`}>
				{title}
			</span>
			{type && <TypeBadge type={type} />}
			<span className="flex-1" />
			{disabled ? (
				<span className="inline-flex items-center gap-1 text-[11px] text-bgBase-800 truncate max-w-[58%] text-right">
					<BsInfoCircle className="w-3.5 h-3.5 flex-shrink-0" />
					{reason}
				</span>
			) : (
				<>
					{!open && summary && (
						<span className="text-xs text-bgBase-800 truncate max-w-[45%] text-right">{summary}</span>
					)}
					{open ? (
						<BsChevronUp className="w-3.5 h-3.5 text-bgBase-800 flex-shrink-0" />
					) : (
						<BsChevronDown className="w-3.5 h-3.5 text-bgBase-800 flex-shrink-0" />
					)}
				</>
			)}
		</button>
		{open && !disabled && (
			<div className="px-4 pb-4 pt-1 space-y-3 border-t border-gray-100 rounded-b-xl">{children}</div>
		)}
	</div>
);

CollapseCard.propTypes = {
	icon: PropTypes.elementType.isRequired,
	title: PropTypes.string.isRequired,
	type: PropTypes.oneOf(['maps', 'hr']),
	summary: PropTypes.string,
	open: PropTypes.bool,
	onToggle: PropTypes.func,
	disabled: PropTypes.bool,
	reason: PropTypes.string,
	span2: PropTypes.bool,
	children: PropTypes.node,
};
